export const sxStyled = () => ({
  contenedorCuentasBancarias: {
    px: { xs: '40px', md: '85px' },
  },

  title: {
    mt: '40px',
  },

  subTitleContainer: {
    mt: '35px',
    mb: '35px',
    fontSize: '25px',
    color: '#9a9a9a',
  },

  subTitle: {
    color: 'black',
    fontSize: '28px',
  },

  cardTitle: {
    color: 'black',
  },

  contenedorBancos: {
    mt: '40px',
    mb: '20px',
  },

  cuentasBancarias: {
    pb: '20px',
  },

  iconos: {
    height: '52px',
    pb: '10px',
  },

  contenedorAclaraciones: {
    mb: '35px',
  },

  contenedorTarjetasDeCredito: {
    bgcolor: '#E5E5E5',
    px: { xs: '40px', md: '85px' },
  },

  contenedorTarjetas: {
    mt: '20px',
    justifyContent: 'start',
  },

  subInformacionTarjetas: {
    color: 'red',
  },

  contenedorInformacionImportante: {
    mt: '20px',
    mb: '20px',
  },

  contenedorSubtituloInformacionImportante: {
    mb: '10px',
  },

  contenedorCartaAutorizacion: {
    px: { xs: '40px', md: '85px' },
    pb: '25px',
  },

  contenedorSubTituloCartaAutorizacion: {
    mt: '20px',
    mb: '10px',
  },

  contenedorDescarga: {
    mt: '25px',
    bgcolor: '#C2E6FA',
    width: { xs: '100%', md: '30%' },
    borderRadius: '5px',
    p: '10px',
  },

  materialUiIcon: {
    color: '#0a2b5f',
    bgcolor: 'white',
    p: '7px',
    borderRadius: '50px',
    mr: '13px',
    ml: '15px',
  },

  contenedorLink: {
    display: 'flex',
    flexDirection: 'row',
    textDecoration: 'none',
    alignItems: 'center',
  },

  miniContenedor: {
    width: '100%',
  },
});
